import $$ from 'cmn-utils'

const baseUrl = "/api/prospect/template/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    listTask: (params) => {
        return $$.get(baseUrl + 'list-task', params)
    },
}